export class Pageable<T> {
    constructor(
      private pItems: T[] = [],
      private pCurrentPage = 1,
      private pTotalPages = 1,
      private pTotalItems = 0,
      private pItemsPerPage = 30,
      private pView = ''
    ) {}
  
    get items(): T[] {
      return this.pItems;
    }
  
    get currentPage(): number {
      return this.pCurrentPage;
    }
  
    get totalPages(): number {
      return this.pTotalPages;
    }
  
    get totalItems(): number {
      return this.pTotalItems;
    }
  
    get itemsPerPage(): number {
      return this.pItemsPerPage;
    }
  
    get view(): string {
      return this.pView;
    }

    removeItem(item:T){
      this.pItems = this.pItems.filter(x => x != item);
      this.pTotalItems = this.pTotalItems -1; 
      return this.clone()
    }
  
    clone(): Pageable<T> {
      return new Pageable<T>(
        this.pItems,
        this.pCurrentPage,
        this.pTotalPages,
        this.pTotalItems,
        this.pItemsPerPage,
        this.pView
      );
    }
  }
  